export default __webpack_public_path__ + "static/quoteCarousel-a634842032bebee9ae923f2c963e0b88.png";